import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import { Grid } from 'semantic-ui-react';
import isEmpty from 'lodash/isEmpty';
import { classNames } from '../../../../../../utils/classname';
import { formatDay, formatTime } from '../../../../../hours/services/format';
import { groupHours } from '../../../../../hours/services/grouping';
import { HourPropType } from '../../TeamMember.types';
import './Schedule.css';
var defaultProps = {
  className: ''
};
export default function Schedule(_ref) {
  var className = _ref.className,
    hoursProp = _ref.hours;
  if (isEmpty(hoursProp)) {
    return null;
  }
  var finalClassName = classNames(_defineProperty({
    schedule: true,
    hours: true
  }, className, true));
  var hoursByDay = groupHours(hoursProp);
  return /*#__PURE__*/React.createElement(Grid, {
    className: finalClassName,
    columns: 2
  }, hoursByDay.map(function (_ref2) {
    var day = _ref2.day,
      hours = _ref2.hours;
    return /*#__PURE__*/React.createElement(Grid.Row, {
      key: day
    }, /*#__PURE__*/React.createElement(Grid.Column, {
      className: "label-column",
      width: 7
    }, /*#__PURE__*/React.createElement("p", null, formatDay(day))), /*#__PURE__*/React.createElement(Grid.Column, {
      className: "detail-column",
      textAlign: "right",
      width: 9
    }, hours.map(function (_ref3) {
      var openTime = _ref3.openTime,
        closeTime = _ref3.closeTime;
      var formattedTime = formatTime(openTime, closeTime);
      return /*#__PURE__*/React.createElement("p", {
        key: day + formattedTime
      }, formattedTime);
    })));
  }));
}
Schedule.defaultProps = defaultProps;